import { SwitchInfo } from 'builder';

export const states: SwitchInfo[] = [
    {
        "state": "0",
        "name": "Ord",
        "description": "Klicka på kryssplanen för att välja en ruta och skriv sedan in rätt ord. Klicka igen för att byta riktning."
    },
    {
        "state": "1",
        "name": "Mörka rutor",
        "description": "Klicka på kryssplanen för att göra en ruta svart. Klicka igen för att göra den vit igen."
    },
    {
        "state": "2",
        "name": "Siffra",
        "description": "Klicka på den ruta som är först i ett ord svar. Klicka igen för att ta bort siffran."
    },
    {
        "state": "3",
        "name": "Vinkelord",
        "description": "Klicka på en ruta där ett ord är vinklat. Klicka igen för att byta vinkel samt en tredje gång för att ta bort pilen."
    },
    {
        "state": "4",
        "name": "Bindestreck",
        "description": "Klicka på en ruta där ett svar delas med ett bindestreck. Klicka igen för att byta riktning på strecket samt en tredje gång för att ta bort det.",
        "example": "Cdskiva blir cd-skiva"
    },
    {
        "state": "5",
        "name": "Orddelare",
        "description": "Klicka på en ruta där ett svar ska delas upp i flera ord. Klicka igen för att byta riktning på orddelaren samt en tredje gång för att ta bort den.",
        "example": "Gulblomma blir Gul Blomma"
    },
    {
        "state": "6",
        "name": "Fråga",
        "description": "Klicka på en ruta med en startsiffra för att lägga till minnesanteckning. Anteckningar är bara tillgänglig för kryssägaren. (Under utveckling.)",
    }
]
